import supabase from 'lib/supabase-browser'
import { Submission } from 'lib/types/generated-types'
import { SubmissionResponseType } from 'store/useStore'

// Fetch single submission
export async function fetchSubmission(id: string): Promise<Submission> {
  try {
    const { data, error } = await supabase
      .from('submissions')
      .select('*')
      .eq('id', id)
      .single()
    if (error) {
      console.error('Error fetching submission:', error.message)
      throw new Error(error.message)
    }
    const submission = data as Submission
    return submission
  } catch (error) {
    console.error('Error fetching submission:', error.message)
    throw new Error(error.message)
  }
}

export async function upsertSubmissionToDB(
  submission: Partial<Submission>
): Promise<Submission> {
  const { data, error } = await supabase
    .from('submissions')
    .upsert([submission], { onConflict: 'id' })
    .select()

  if (error) {
    console.error('Error adding submission:', error.message)
    throw new Error(error.message)
  }

  const dbSubmission = data![0] as Submission
  return dbSubmission
}

export async function updateSubmissionToDB(
  submission: Partial<Submission>
): Promise<Submission> {
  const { data, error } = await supabase
    .from('submissions')
    .update(submission)
    .eq('id', submission.id || '')
    .select()

  if (error) {
    console.error('Error updating submission:', error.message)
    throw new Error(error.message)
  }

  return data![0] as Submission
}

// Gets the article for a submission based on the article_id field and goes to the responses table
export async function fetSubmissionResponseFromDB(
  submissionId: string,
  type: SubmissionResponseType
): Promise<any> {
  const { data, error } = await supabase
    .from('submissions')
    .select(type)
    .eq('id', submissionId)
    .single()

  if (error) {
    console.error('Error fetching submission article:', error.message)
    throw new Error(error.message)
  }

  const { data: responseObject, error: responseError } = await supabase
    .from('responses')
    .select('response')
    .eq('id', data![type])
    .single()

  if (responseError) {
    console.error('Error fetching submission article:', responseError.message)
    throw new Error(responseError.message)
  }

  return { ...data, response: responseObject?.response }
}

export async function updateSubmissionResponse(
  submissionId: string,
  type: SubmissionResponseType,
  response: string
): Promise<any> {
  const { data, error } = await supabase
    .from('submissions')
    .select(type)
    .eq('id', submissionId)
    .maybeSingle()

  if (error) {
    console.error('Error fetching submission:', error.message)
    throw new Error(error.message)
  }

  const { data: responseObject, error: responseError } = await supabase
    .from('responses')
    .update({ response })
    .eq('id', data![type])
    .single()

  if (responseError) {
    console.error('Error fetching response:', responseError.message)
    throw new Error(responseError.message)
  }

  return responseObject
}
